import curatorshipIcon from '../assests/header/curatorship.png'
import chatAlbertIcon from '../assests/header/chatAlbert.png'
import trainingCampIcon from '../assests/header/trainingCamp.png'

const pathRouts = {

    HOME: {
        route: "home",
        title: "homePage"
    },
    CHATAI: {
        route: "chatAi",
        title: "chatAi",
        img:  chatAlbertIcon ,
        baseName: ["chatAi", "chatAlbert"]
    },
    CHATALBERT: {
        route: "chatAlbert",
        title: "trainingCamp",
        img: trainingCampIcon ,
        baseName: ["chatAlbert"]
    },
    CURATORSHIP: {
        route: "curatorship",
        title: "curatorship",
        img: curatorshipIcon ,
    },
    DELAYNAVIGATE: {
        route: "delay-navigate",
        title: "delayNavigatePageTitle",
    },
};

export default pathRouts;